// extracted by mini-css-extract-plugin
export default {"lineBreak":"RejectedOffer_lineBreak__PSYBG"};